enum EViolationStatus {
  OPEN = 'open',
  WORK = 'work',
  CONFIRMATION = 'confirmation',
  UNCONFIRMED = 'unconfirmed',
  CLOSE = 'close',
}

export default EViolationStatus;
